export default __webpack_public_path__ + "static/media/educators2.b8338131.jpg";